<template>
  <info-message-dialog
    v-if="confirmation"
    :is-open="true"
    :title="confirmation.title"
    :message="confirmation.message"
    @close="emit('cancel')"
  >
    <template #footer>
      <div class="d-flex ga-2">
        <v-btn variant="outlined" size="large" @click="emit('cancel')" :disabled="busy">
          Cancel
        </v-btn>
        <v-btn variant="flat" size="large" @click="emit('confirm')" :disabled="busy">
          {{ confirmation.confirmLabel }}
        </v-btn>
      </div>
    </template>
  </info-message-dialog>
</template>

<script setup>
import InfoMessageDialog from '@/components/InfoMessageDialog.vue'

defineProps({
  confirmation: {
    type: Object,
    default: null
  },
  busy: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['confirm', 'cancel'])
</script>
